//import { IDataIngresoInventario } from "@/shared/interfaces";
import { MaterialTransferido } from "@/shared/interfaces";

import { MRT_ColumnDef, } from "material-react-table";
import { useMemo } from "react";

/* type IDataConsulta={
  data: IDataConsultaIngresoInventario[]
} */
export type IDataConsultaIngresoInventario = {
  orden_compra: string;
  numero_factura?: string;
  numero_guia_remision?: string;
  fecha_creacion?: string;
  productos?: MaterialTransferido[]
}


const useTableIngresoInventarioOrdenFinalizado = () => {
  /*  const onDatils = (e: MRT_RowData)=>{
     console.log(e)
     console.log(e.productos)
     const details = e.productos.map((producto: any)=>({
       
     }))
 
   } */
  const infoIngresoInventario = useMemo<MRT_ColumnDef<IDataConsultaIngresoInventario>[]>(
    () => [
      /* {
        ...cellNotFilter,
        accessorKey: 'detalles',
        header: 'Detalle',
        Cell: ({ row }) => {
          return (
            <Button
            variant="text"
            startIcon={<VisibilityIcon/>}
            onClick={()=>{onDatils(row.original)}}
            >
             {'Ver items'}
            </Button>
          )
        }
      }, */
      {
        accessorKey: 'orden_compra',
        header: 'N° Orden compra',
      },
      {
        accessorKey: 'numero_factura',
        header: 'N° Factura',
        Cell: ({ row }) => row.original?.numero_factura || 'N/A'
      },
      {
        accessorKey: 'numero_guia_remision',
        header: 'N° Remisión',
        Cell: ({ row }) => row.original?.numero_guia_remision || 'N/A'
      },
      /* {
        accessorKey: 'fecha_creacion',
        header:'Fecha Creación'
      } */
    ], [])
  const infoProducto = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(
    () => [

      {
        accessorKey: 'producto_data.descripcion',
        header: 'Descripcion'
      },
      {
        accessorKey: 'producto_data.presentacion',
        header: 'Presentación',
        Cell: ({ row }) => row.original?.producto_data?.presentacion || 'N/A'
      },
      {
        accessorKey: 'cantidad_recibida',
        header: 'Cant. Recibida'
      },
      /* {
         accessorKey:'proveedor',
         header:'Proveedor'
      }, */
      {
        accessorKey: 'cantidad_aprobada',
        header: 'Cantidad'
      },
      {
        accessorKey: 'precio_compra',
        header: 'Precio Unitario'
      },
      {
        accessorKey: 'precio_total',
        header: 'Total'
      },
      /* {
        accessorKey: 'cantidad_aprobada',
        header: 'Cant. Aprobada'
      },
      {
        accessorKey: 'cantidad_pendiente',
        header: 'Cant. Esperada'
      },
      {
        accessorKey: 'cantidad_recibida',
        header: 'Cant. Recibida'
      }, */
      //...infoIngresoInventario 
    ], [],
  )

  return {
    infoIngresoInventario,
    infoProducto,


  }

}
export default useTableIngresoInventarioOrdenFinalizado;